<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Cierre de pagos</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button v-show="consultado" @click="guardar" class="btn-success btn--bigger">
            <i class="fa fa-save"></i>
            <span>Guardar</span>
          </button>
          <button v-show="consultado" @click="cancelar" class="btn-warning btn--bigger">
            <i class="fa fa-ban"></i>
            <span>Cancelar</span>
          </button>
          <button @click="consultar" v-show="!consultado" class="btn-info btn--bigger">
            <i class="fa fa-search"></i>
            <span>Consultar</span>
          </button>
          <button @click="irACierres" class="btn-primary btn--bigger">
            <i class="fa fa-table"></i>
            <span>Ir a consulta de cierres</span>
          </button>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card__title">
        <h5>Información de cierre</h5>
      </div>
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12">
            <div class="form-inline">
              <label for="alafecha">
                <input
                  :disabled="consultado"
                  v-model="form.tipo_fecha"
                  value="F"
                  type="radio"
                  name="tipo_fecha"
                  id="alafecha"
                />
                <span>A la fecha</span>
              </label>
              <label for="hoy">
                <input
                  :disabled="consultado"
                  v-model="form.tipo_fecha"
                  value="H"
                  type="radio"
                  name="tipo_fecha"
                  id="hoy"
                />
                <span>Hoy</span>
              </label>
              <label for="ayer">
                <input
                  :disabled="consultado"
                  v-model="form.tipo_fecha"
                  value="A"
                  type="radio"
                  name="tipo_fecha"
                  id="ayer"
                />
                <span>Ayer</span>
              </label>
              <label for="personalizado">
                <input
                  :disabled="consultado"
                  @change="changePersonalizado"
                  v-model="form.tipo_fecha"
                  value="P"
                  type="radio"
                  name="tipo_fecha"
                  id="personalizado"
                />
                <span>Personalizado</span>
              </label>
            </div>
          </div>
          <div v-show="form.tipo_fecha === 'P'" class="col-xs-12 col-md-4">
            <div class="form-field">
              <div class="datepicker-field datepicker-field--stretch">
                <VueCtkDateTimePicker
                  :disabled="consultado"
                  id="fecha_inicio"
                  label="YYYY-MM-DD"
                  v-model="form.fecha_inicio"
                  locale="es"
                  no-label
                  only-date
                  button-now-translation="Ahora"
                  format="YYYY-MM-DD"
                  formatted="YYYY-MM-DD"
                />
                <label for="fecha_inicio">Desde</label>
                <span v-if="errores.fecha_inicio" class="helper-text text-danger" slot="helper">
                  <strong>{{ errores.fecha_inicio[0] }}</strong>
                </span>
              </div>
            </div>
          </div>
          <div v-show="form.tipo_fecha === 'P'" class="col-xs-12 col-md-4">
            <div class="form-field">
              <div class="datepicker-field datepicker-field--stretch">
                <VueCtkDateTimePicker
                  :disabled="consultado"
                  id="fecha_corte"
                  v-model="form.fecha_corte"
                  locale="es"
                  no-label
                  only-date
                  button-now-translation="Ahora"
                  format="YYYY-MM-DD"
                  label="YYYY-MM-DD"
                  formatted="YYYY-MM-DD"
                />
                <label for="fecha_corte">Hasta</label>
                <span v-if="errores.fecha_corte" class="helper-text text-danger" slot="helper">
                  <strong>{{ errores.fecha_corte[0] }}</strong>
                </span>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-2">
            <p>
              <label for="todos_doctores">
                <input
                  :disabled="consultado"
                  type="checkbox"
                  name="todos_doctores"
                  id="todos_doctores"
                  v-model="form.todos_doctores"
                />
                <span>Todos los médicos</span>
              </label>
            </p>
          </div>
          <div v-show="!form.todos_doctores" class="col-xs-12 col-md-4">
            <div
              class="form-field select2"
              :class="{

                            'select2--disabled' : consultado
                        }"
            >
              <div class="select2-field select2-field--stretch">
                <v-select
                  multiple
                  placeholder="Seleccione..."
                  @input="inputDoctores"
                  id="doctor"
                  v-model="selectedDoctores"
                  :options="doctores"
                  label="nombre_cabecera"
                ></v-select>
                <label for="doctor">Médicos</label>
                <span v-if="errores.doctor_id" class="helper-text text-danger" slot="helper">
                  <strong>{{ errores.doctor_id[0] }}</strong>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-for="(doctor, index) in doctoresCierre" :key="doctor.id" class="row mt-2">
      <div class="col-xs-12">
        <item-cierre-pago
          :titulo="doctoresCierre[index].doctor"
          v-model="doctoresCierre[index].cierres"
          :index="index"
        ></item-cierre-pago>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-xs-12">
        <div class="card">
          <div class="card__title">
            <h5>Totales generales</h5>
          </div>
          <div class="card__content">
            <div class="table-responsive">
              <table>
                <thead>
                  <tr>
                    <th>Total de consultas</th>
                    <th>Valor total en consultas</th>
                    <th>Valor final a cancelar</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ totalConsultas }}</td>
                    <td>{{ moneyFormat(valorTotalConsultas) }}</td>
                    <td>{{ moneyFormat(valorFinalCancelar) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-xs-12">
        <div class="card">
          <div class="card__content">
            <div class="row">
              <div class="col-xs-12">
                <div class="form-field">
                  <textarea-field
                    id="observacion"
                    placeholder="Escriba una observación..."
                    v-model="observacion"
                  >
                    <span>Observación*</span>
                    <span v-if="errores.observacion" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores.observacion[0] }}</strong>
                    </span>
                  </textarea-field>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cierrePago: {
      type: Object,
      required: false,
      default: function() {
        return null;
      }
    },
    doctores: {
      type: Array,
      required: false,
      default: function() {
        return [];
      }
    }
  },
  computed: {
    totalConsultas: function() {
      let total = 0;
      for (let i = 0; i < this.doctoresCierre.length; i++) {
        for (let j = 0; j < this.doctoresCierre[i].cierres.length; j++) {
          if (this.doctoresCierre[i].cierres[j].conciliada) {
            total += 1;
          }
        }
      }
      return total;
    },
    valorTotalConsultas: function() {
      let valor = 0;
      for (let i = 0; i < this.doctoresCierre.length; i++) {
        for (let j = 0; j < this.doctoresCierre[i].cierres.length; j++) {
          if (this.doctoresCierre[i].cierres[j].conciliada) {
            valor += parseFloat(
              this.doctoresCierre[i].cierres[j].valor_consulta
            );
          }
        }
      }
      return valor;
    },
    valorFinalCancelar: function() {
      let valor = 0;
      for (let i = 0; i < this.doctoresCierre.length; i++) {
        for (let j = 0; j < this.doctoresCierre[i].cierres.length; j++) {
          if (this.doctoresCierre[i].cierres[j].conciliada) {
            valor += parseFloat(this.doctoresCierre[i].cierres[j].valor_medico);
          }
        }
      }
      return valor;
    }
  },
  data: function() {
    return {
      moneyFormat: moneyFormat,
      selectedDoctores: [],
      form: {
        doctores: [],
        fecha_inicio: "",
        fecha_corte: "",
        tipo_fecha: "F",
        todos_doctores: true
      },
      errores: {},
      consultado: false,
      doctoresCierre: [],
      observacion: ""
    };
  },
  methods: {
    cancelar: function() {
      this.doctoresCierre.splice(0, this.doctoresCierre.length);
      this.form.fecha_corte = "";
      this.form.fecha_inicio = "";
      this.form.tipo_fecha = "F";
      this.form.todos_doctores = true;
      this.errores = {};
      this.consultado = false;
    },
    inputDoctores: function() {
      this.form.doctores.splice(0, this.form.doctores.length);
      for (let i = 0; i < this.selectedDoctores.length; i++)
        this.form.doctores.push(this.selectedDoctores[i].id);
    },
    changePersonalizado: function() {
      if (!this.consultado) {
        this.form.fecha_corte = moment(new Date()).format("YYYY-MM-DD");
        let fecha_inicio = new Date();
        fecha_inicio.setDate(fecha_inicio.getDate() - 30);
        this.form.fecha_inicio = moment(fecha_inicio).format("YYYY-MM-DD");
      }
    },
    irACierres: function() {
      location.href = url + "/cierre-pago";
    },
    consultar: function() {
      this.errores = {};
      let that = this;
      axios
        .get(url + "/consultas-cierre", {
          params: this.form
        })
        .then(function(response) {
          that.doctoresCierre.splice(0, that.doctoresCierre.length);
          let data = response.data;
          let keys = Object.keys(data);
          for (let i = 0; i < keys.length; i++) {
            let firstItem = data[keys[i]][0];
            that.doctoresCierre.push({
              doctor: firstItem.doctor.nombre_cabecera,
              cierres: data[keys[i]]
            });
          }
          that.consultado = true;
        })
        .catch(function(error) {
          if (error.response) {
            let response = error.response;
            if (response.status === 422) {
              that.errores = response.data.errors;
              swal("Hay errores en el formulario.", "Aviso", "warning");
              return;
            }
            swal("Hubo un error, intente nuevamente.", "Error", "error");
          }
        });
    },
    guardar: function() {
      this.errores = {};
      let that = this;
      let finalForm = {
        fecha_inicio: this.form.fecha_inicio,
        fecha_corte: this.form.fecha_corte,
        tipo_fecha: this.form.tipo_fecha,
        consultas: [],
        observacion: this.observacion,
        total_cancelado: this.valorFinalCancelar,
        consultas_totales: this.totalConsultas,
        id: this.cierrePago !== null ? this.cierrePago.id : null
      };
      for (let i = 0; i < this.doctoresCierre.length; i++) {
        for (let j = 0; j < this.doctoresCierre[i].cierres.length; j++) {
          if (this.doctoresCierre[i].cierres[j].conciliada)
            finalForm.consultas.push(this.doctoresCierre[i].cierres[j].id);
        }
      }
      if (finalForm.consultas.length > 0) {
        swal({
          title: "¿Desea realizar el cierre de pagos?",
          text: "Se requiere de confirmación del usuario",
          type: "question",
          showCancelButton: true,
          confirmButtonText: "Cerrar",
          cancelButtonText: "No"
        }).then(result => {
          if (result.value) {
            axios
              .post(url + "/cierre-pago", finalForm)
              .then(function() {
                swal({
                  type: "success",
                  title: "Realizado",
                  text: "El cierre de pagos ha sido almacenado exitósamente.",
                  onClose: () => {
                    that.irACierres();
                  }
                });
              })
              .catch(function(error) {
                if (error.response) {
                  let response = error.response;
                  if (response.status === 422) {
                    that.errores = response.data.errors;
                    swal("Hay errores en el formulario.", "Aviso", "warning");
                  } else
                    swal(
                      "Hubo un error, intente nuevamente.",
                      "Error",
                      "error"
                    );
                }
              });
          }
        });
      } else swal("Debe conciliar el menos una consulta.", "Aviso", "warning");
    }
  },
  mounted: function() {
    if (this.cierrePago !== null) {
      this.consultado = true;
      if (this.cierrePago.fecha_inicio !== null) {
        this.form.tipo_fecha = "P";
        this.form.fecha_inicio =
          this.cierrePago.fecha_inicio !== null
            ? moment(new Date(this.cierrePago.fecha_inicio)).format(
                "YYYY-MM-DD"
              )
            : this.cierrePago.fecha_inicio;
        this.form.fecha_corte = moment(
          new Date(this.cierrePago.fecha_corte)
        ).format("YYYY-MM-DD");
      } else this.form.tipo_fecha = "F";
      this.observacion = this.cierrePago.observacion;
      let data = this.cierrePago.consultasAgrupadas;
      let keys = Object.keys(data);
      for (let i = 0; i < keys.length; i++) {
        let firstItem = data[keys[i]][0];
        this.doctoresCierre.push({
          doctor: firstItem.doctor.nombre_cabecera,
          cierres: data[keys[i]]
        });
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/procesos/CierrePago.vue